import React, { useState } from "react";
import { Form, Input } from "antd";
import Button from "components/Button";
import jMoment from "moment-jalaali";
import { inject, observer } from "mobx-react";
import { get } from "lodash";

const { TextArea } = Input;

interface IProps {
	messages: Record<string, any>[];
	sendMessage: (text: string) => void;
	user?: Record<string, any>;
}

const Messenger = (props: IProps) => {
	const { messages, sendMessage } = props;
	const [text, setText] = useState("");
	const [currentNum, setCurrentNum] = useState(0);
	const [messagesList, setMessagesList] = useState(messages);
	// @ts-ignore
	const user = props.user.getUser.profile;

	const fullName = `${get(user, "firstname")} ${get(user, "lastname")}`;

	const onChangeText = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		e.preventDefault();
		setText(e.target.value);
	};

	const handleSubmit = () => {
		const date = new Date();
		sendMessage(text);
		setMessagesList([
			...messagesList,
			{
				body: text,
				userMsg: true,
				createdDate: date.getMilliseconds(),
				operatorName: null,
			},
		]);
		setText("");
		setTimeout(() => {
			setCurrentNum(currentNum + 1);
		}, 1000);
	};

	return (
		<div style={{ display: "flex", maxWidth: "100%", flexDirection: "column" }}>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					padding: "20px",
					width: "100%",
				}}
			>
				{messagesList.length > 0
					? messagesList.map((msg: Record<string, any>) => {
							return (
								<div
									style={{
										position: "relative",
										display: "flex",
										width: "auto",
										minHeight: "auto",
										backgroundColor: msg.userMsg ? "#e8ce66" : "#cf9767",
										borderRadius: "15px",
										lineHeight: "20px",
										boxSizing: "border-box",
										margin: "10px 0",
										padding: "0",
									}}
									key={msg.id}
								>
									<div style={{ width: "100%" }}>
										<div
											style={{
												display: "flex",
												position: "relative",
												justifyContent: "space-between",
												borderRadius: "15px 15px 0 0",
												width: "100%",
												padding: "5px 10px",
												backgroundColor: msg.userMsg ? "#e3c036" : "#d1813d",
											}}
										>
											<div>
												<h4>{msg.userMsg ? fullName : msg.operatorName}</h4>
												<p style={{ marginLeft: "10px", fontSize: ".7rem" }}>
													{msg.userMsg ? "کاربر" : "اپراتور"}
												</p>
											</div>
											<p style={{ height: "100%", lineHeight: "100%", direction: "ltr" }}>
												{jMoment(msg.createdDate).format("jYYYY/jMM/jDD HH:mm")}
											</p>
										</div>
										<p style={{ padding: "10px" }}>{msg.body}</p>
									</div>
								</div>
							);
					  })
					: null}
			</div>
			<div style={{ width: "100%", padding: "20px" }}>
				<Form style={{ display: "flex", marginTop: "20px", flexDirection: "column" }} onSubmit={handleSubmit}>
					<h3 style={{ marginBottom: "10px" }}>پاسخ</h3>
					<TextArea
						value={text}
						style={{ width: "100%", borderRadius: "15px", height: "200px" }}
						onChange={onChangeText}
					/>
					<Button
						style={{ margin: "auto", width: "200px" }}
						disabled={text.length === 0}
						htmlType="submit"
						primary
					>
						فرستادن
					</Button>
				</Form>
			</div>
		</div>
	);
};

export default inject("user")(observer(Messenger));
